import colors from 'theme/colors'
import css from 'styled-jsx/css'
const color = colors.capriBlue
export default css`
  .button.info.outline {
    border-color: ${color};

    transition: 100ms background-color, 100ms border-color;
  }

  .button.info.outline {
    color: ${color};

    transition: 100ms color;
  }

  .button:not(.disabled):hover.info.outline, .button:not(.disabled):focus.info.outline {
    background-color: ${color};
    color: ${colors.white};

    transition: 100ms background-color, 100ms color;
  }
`